import { Model } from 'pinia-orm';
import Interview from "./Interview";
import Invitation from "./Invitation";

export default class InterviewInvitation extends Model {

    static get entity () {
        return 'interview-invitations'
    }

    static fields () {
        return {
            id: this.uid(),
            outbound_email_id: this.attr(null),
            interview_id: this.attr(null),
            confirmation_subject: this.attr(null),
            confirmation_message: this.attr(null),
            confirmed_at: this.attr(null),
            duration: this.attr(null),

            //relationships
            email: this.belongsTo(Invitation, 'outbound_email_id'),
            interview: this.belongsTo(Interview, 'interview_id'),
        }
    }
}
